module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _vm._v("Maps")]), _vm._v(" "), _c('div', {
    staticClass: "nl"
  }, [_c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch1.htm#map_01"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("1")]), _vm._v("Europe, August 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch1.htm#map_02"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("2")]), _vm._v("Naval plans against Germany, 1914–15")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch3.htm#map_03"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("3")]), _vm._v("The Dardanelles defences")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch6.htm#map_04"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("4")]), _vm._v("The Gallipoli Peninsula")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch6.htm#map_05"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("5")]), _vm._v("The topography at Anzac")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch6.htm#map_06"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("6")]), _vm._v("The military plan")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch7.htm#map_07"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("7")]), _vm._v("Landings and objectives, 25 April")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch7.htm#map_08"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("8")]), _vm._v("The Helles Landing")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch8.htm#map_09"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("9")]), _vm._v("Anzac: the situation at the end of April")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch8.htm#map_10"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("10")]), _vm._v("Anzac: the situation on 19 May")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch9.htm#map_11"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("11")]), _vm._v("The First Battle of Krithia, 28 April")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch9.htm#map_12"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("12")]), _vm._v("The Turkish night attack, 1–2 May")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch9.htm#map_13"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("13")]), _vm._v("The Second Battle of Krithia, 6–8 May: the objectives")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch9.htm#map_14"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("14")]), _vm._v("The Second Battle of Krithia, 6–8 May")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch10.htm#map_15"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("15")]), _vm._v("The Third Battle of Krithia, 4 June")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch10.htm#map_16"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("16")]), _vm._v("Helles: ground gained, 21 June–13 July")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch12.htm#map_17"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("17")]), _vm._v("The Anzac plan: August")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch12.htm#map_18"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("18")]), _vm._v("Anzac: evening, 7 August")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch12.htm#map_19"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("19")]), _vm._v("Anzac: evening, 8 August")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch12.htm#map_20"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("20")]), _vm._v("Anzac: evening, 9 August")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch12.htm#map_21"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("21")]), _vm._v("Anzac: dawn, 10 August")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch13.htm#map_22"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("22")]), _vm._v("Suvla Bay: the objectives")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch13.htm#map_23"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("23")]), _vm._v("Suvla Bay: Turkish dispositions, 6 August")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch13.htm#map_24"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("24")]), _vm._v("Suvla Bay: morning, 7 August")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch13.htm#map_25"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("25")]), _vm._v("Suvla Bay: evening, 7 August")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch13.htm#map_26"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("26")]), _vm._v("Suvla Bay: evening, 8 August")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch15.htm#map_27"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("27")]), _vm._v("The evacuation of Anzac, 20 December")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/ch15.htm#map_28"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("28")]), _vm._v("The evacuation of Helles, 8–9 January 1916")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-151ac535","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list_of_maps.vue
// module id = 72
// module chunks = 0